import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { LogService } from '../../logging/log.service';

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    LOG_SOURCE = 'TokenService';

    constructor(private readonly keycloakService: KeycloakService, private readonly logService: LogService) {}

    getToken(): Promise<string> {
        this.logService.info(this.LOG_SOURCE, 'Getting keycloak token', {});
        return this.keycloakService.getToken();
    }
}
